import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  startup: null,
  setLoading: ['loading'],
  setAppDataLoadRequest: null,
  setLoaded: ['loaded'],
  setAllOffices: ['offices'],
  setSearchData: ['cities', 'states', 'regions']
});

export const AppTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  loaded: false,
  offices: [],
  states: [],
  cities: [],
  regions: []
};

/* ------- Selectors --------- */
export const AppSelectors = {
  selectLoading: state => state.app.loading,
  selectLoaded: state => state.app.loaded,
  selectOffices: state => state.app.offices,
  selectCities: state => state.app.cities,
  selectStates: state => state.app.states,
  selectRegions: state => state.app.regions
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setLoaded = (state, { loaded }) => ({
  ...state,
  loaded
});

export const setOffices = (state, { offices }) => ({
  ...state,
  offices
});

export const setSearchData = (state, { cities, states, regions }) => ({
  ...state,
  cities,
  states,
  regions
});

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOADING]: setLoading,
  [Types.SET_LOADED]: setLoaded,
  [Types.SET_SEARCH_DATA]: setSearchData,
  [Types.SET_ALL_OFFICES]: setOffices
});
